const ProjectData = [
  {
    id: "1",
    img: "https://raw.githubusercontent.com/maligaurav947/Portfolio/master/src/Components/assets/img/musemeld.png",
    title: "musemeld",
    tags: ["React.js", "TailwindCSS", "Firebase"],
    info: "I developed a feature-rich social media app using React.js and Firebase, which included user authentication, real-time data updates, and a user-friendly interface. The project allowed users to sign in or sign up via email and Google authentication, create, edit, and delete posts, view user profiles, and interact with posts in real-time",
    link: "https://github.com/maligaurav947/musemeld",
    data: "top",
  },
  {
    id: "2",
    img: "https://github.com/maligaurav947/Portfolio/blob/master/src/Components/assets/img/task.png?raw=true",
    title: "React Task Managament",
    tags: ["HTML", "React.js", "TailwindCSS"],
    info: "This is a simple task management app built using React that allows you to manage your tasks based on three levels of priority: High, Medium, and Low. You can create, edit, delete tasks, and also move them between different priority lists With Local Session Storage System.",
    link: "https://maligaurav947.github.io/react-task-management/",
    data: "top",
  },
  {
    id: "3",
    img: "https://github.com/maligaurav947/Portfolio/blob/master/src/Components/assets/img/main-home.png?raw=true",
    title: "Moviedb React",
    tags: ["HTML", "TailwindCSS", "React.js", "Router"],
    info: "Explore your favorite movies and learn more about their cast with the Movie Explorer app. This React-based web application fetches movie data from the TMDB API and provides a user-friendly interface to discover movie details, cast information, and more.",
    link: "https://maligaurav947.github.io/moviedb-react/",
    data: "top",
  },
  {
    id: "4",
    img: "https://github.com/maligaurav947/Portfolio/blob/master/src/Components/assets/img/Reactecommercestoere.png?raw=true",
    title: "React Ecommerce Store",
    tags: ["React", "HTML", "AOS", "BootStrap", "BootStrap Components"],
    info: "I developed a responsive Ecommerce Store using React, featuring product catalog, user authentication, shopping cart, and secure payment integration. The project showcases my proficiency in front-end development, UI/UX design, state management, and third-party service integration.",
    link: "https://maligaurav947.github.io/react-ecommerce-store/",
    data: "top",
  },
  {
    id: "5",
    img: "https://github.com/maligaurav947/Portfolio/blob/master/src/Components/assets/img/Weather-react-app.png?raw=true",
    title: "React Weather App",
    tags: ["React", "HTML", "Axios", "API", "Router", "TailWindCSS"],
    info: "A responsive React web app that provides real-time weather information for global locations. Users can search for cities, view current conditions, forecasts, and toggle between units. Developed using React, CSS for styling, and integrated with a weather API. Demonstrates my proficiency in React, UI design, API integration, and responsive development.",
    link: "https://maligaurav947.github.io/react-weather-app/",
    data: "top",
  },
  {
    id: "6",
    img: "https://github.com/maligaurav947/Portfolio/blob/master/src/Components/assets/img/reactquizapp.png?raw=true",
    title: "React Quiz App",
    tags: ["HTML", "React.js", "TailwindCSS"],
    info: "Engage users with my React-based Quiz App, offering diverse quiz categories, dynamic question rendering, and real-time feedback. Users can track their scores, experience timed challenges, and receive a comprehensive summary of their performance. Designed with a responsive interface, the app ensures seamless usage across devices. Showcase your knowledge and passion in a fun, educational way.",
    link: "https://maligaurav947.github.io/react-weather-app/",
    data: "top",
  },
  {
    id: "7",
    img: "https://github.com/maligaurav947/Portfolio/blob/master/src/Components/assets/img/reactstudentdeatils.png?raw=true",
    title: "Student Details System",
    tags: ["React.js", "HTML", "Firebase", "TailwindCSS", "Responsive Design"],
    info: "The Student Details System is a comprehensive software solution designed to facilitate the efficient management of student information within educational institutions such as schools, colleges, and universities. It provides administrators, teachers, and other relevant stakeholders with a user-friendly interface to access, update, and analyze student data. The system aims to streamline administrative tasks, enhance communication, and improve overall organizational efficiency.",
    link: "https://maligaurav947.github.io/react-weather-app/",
    data: "top",
  },
];

export default ProjectData;
